function FeatureCard({ Icon, title, description }) {
  return (
    <div className="max-w-[17.625rem] h-full px-[1.75rem] py-[3rem] text-pet-tag flex flex-col text-center items-center rounded-2xl border-[2px] border-white bg-[#ffffffbf]">
      <Icon />
      <h2 className="text-[1.5rem] font-bold mb-[1.5rem] mt-[2rem]">{title}</h2>
      <p className="text-[1rem] font-normal">{description}</p>
    </div>
  );
}

export default FeatureCard;
